import analytics from 'modules/analytics';
import { globalContext } from 'modules/analytics/constants';
import { Cache } from '../links/precacheLink';
import type { GetBaseViewerDataQueryVariables } from 'generated/graphql';
import type { DocumentNode } from '@apollo/client';
import { getPrecacheOperationKey } from './getPrecacheOperationKey';

export async function emitPrecacheStatus(
  query: DocumentNode,
  variables: GetBaseViewerDataQueryVariables
): Promise<void> {
  const cache = await Cache.open();
  const operationKey = getPrecacheOperationKey(query, variables);
  const operationUrl = new URL(operationKey, window.location.origin);
  const cacheResponse = await cache.match(operationUrl);
  analytics.addViewContext(globalContext.viewer.precacheStatus, {
    source: cacheResponse ? 'precache' : 'network',
    worklistIds: variables.worklistIds,
  });
}
